module.exports = {
    binSize: 2,
}
